import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Card, Spinner } from "reactstrap";
import { useTranslation } from "context/TranslationProvider";
import helpers from "utils/helpers";
import Pagination from "../../components/Pagination";

const OrderEventsTable = ({ orderEvents = [], isLoading = false }) => {
  const { t, language } = useTranslation();
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const paginatedEvents = orderEvents.slice(
    currentPage * rowsPerPage,
    (currentPage + 1) * rowsPerPage
  );

  const columns = [
    {
      dataField: "createdAt",
      text: t("table.headers.date", "Journey Date"),
      headerAlign: "left",
      align: "left",
      sort: true,
      formatter: (_, row) =>
        helpers.getFormattedDate(row.createdAt, t) || "-",
    },
    {
      dataField: "event_type",
      text: t("table.headers.eventType", "Event Type"),
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => {
        const statusKey = helpers.normalizeOrderStatus(row.event_type);
        const statusClass = helpers.getStatusClass(statusKey, "order");

        return (
          <span
            className={`px-2 py-1 rounded text-xs font-weight-bold ${statusClass}`}
          >
            {t(
              `page.orders.status.${statusKey}`,
              helpers.ORDER_STATUS_API_MAP[statusKey] || row.event_type || "-"
            )}
          </span>
        );
      },
    },
    {
      dataField: "message",
      text: t("table.headers.message", "Message"),
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => row.message || "-",
    },
    {
      dataField: "changed_by",
      text: t("table.headers.changedBy", "Changed By"),
      headerAlign: "left",
      align: "left",
      formatter: (_, row) =>
        row.changed_by
          ? `${row.changed_by.firstName || ""} ${row.changed_by.lastName || ""}`
          : t("page.orders.events.system", "System"),
    },
  ];


  const renderLoading = () => (
    <div className="center-loader">
      <div className="center-loader-content">
        <Spinner />
        <p className="mt-3 text-muted">{t("common.loading", "Loading....")}</p>
      </div>
    </div>
  );

  return (
    <Card className="shadow mb-4">
      <div className="py-4">
        <div className="px-4 pb-2">
          <h4 className="mb-3 text-primary font-weight-bold">
            {t("page.orders.events.title", "Order Events")}
          </h4>
        </div>

        {isLoading ? (
          renderLoading()
        ) : (
          <ToolkitProvider
            keyField="_id"
            data={orderEvents}
            columns={columns}
            search={false}
          >
            {(props) => (
              <div className="w-full flex flex-col">
                <div className="table-responsive max-h-[60vh] overflow-y-auto px-4">
                  <BootstrapTable
                    key={language}
                    {...props.baseProps}
                    data={paginatedEvents}
                    bootstrap4
                    bordered
                    noDataIndication={() => (
                      <div className="text-center py-6 text-muted">
                        {t("page.orders.events.empty", "No order events available yet.")}
                      </div>
                    )}
                  />
                </div>
                <Pagination
                  totalRows={orderEvents.length}
                  rowsPerPage={rowsPerPage}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                  onRowsPerPageChange={(size) => setRowsPerPage(size)}
                  t={t}
                />
              </div>
            )}
          </ToolkitProvider>
        )}
      </div>
    </Card>
  );
};

export default OrderEventsTable;